<!-- MOLECULE: DrawerItem.vue -->

<script setup lang="ts">
//
// Composables
//

// Drawer
const { isPathActive } = useDrawer();

//
// Props
//
const props = withDefaults(
  defineProps<{
    to: string;
    icon: string;
    title: string;
    tooltipText?: string;
    external?: boolean;
  }>(),
  {
    tooltipText: "",
    external: false,
  },
);

//
// Computed Properties
//

// Check if the drawer item is active based on the current route
const isActive = computed(() => isPathActive(props.to));
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props: tooltipProps }">
      <v-list-item
        v-bind="tooltipProps"
        :to="!external ? to : undefined"
        :href="external ? to : undefined"
        :target="external ? '_blank' : undefined"
        :rounded="true"
        :active="isActive"
        :class="{ 'text-primary': isActive }"
        :prepend-icon="icon"
        :title="title"
      >
      </v-list-item>
    </template>

    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
